import { render, staticRenderFns } from "./ActivateCompanyEmployee.vue?vue&type=template&id=8bc21b92"
import script from "./ActivateCompanyEmployee.vue?vue&type=script&lang=js"
export * from "./ActivateCompanyEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports